import createIcon from '../../createIcon';

/**
 * @component @name ArrowBackIosNew
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuODg1MiAzLjc3TDE2LjExNTIgMkw2LjExNTIzIDEyTDE2LjExNTIgMjJMMTcuODg1MiAyMC4yM0w5LjY1NTIzIDEyTDE3Ljg4NTIgMy43N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowBackIosNew = createIcon('ArrowBackIosNew', [
  [
    'path',
    {
      d: 'M17.8852 3.77L16.1152 2L6.11523 12L16.1152 22L17.8852 20.23L9.65523 12L17.8852 3.77Z',
      key: '5iglf3',
    },
  ],
]);

export default ArrowBackIosNew;
